import Actions from '../store/actions';

export const logout = () => ({
  type: Actions.logout,
});
